export const GL_APPROVAL_LIMIT = "v1/approval-limits";
export const POSITION_APPROVAL_LIMIT = "v1/position-approval-limits";
export const COMMUNITY_APPROVAL_LIMIT = "v1/community-approval-limits";
